export const SHOW_MESSAGE_SECONDS = 10;

export const message = (label, labelParameters = {}, type = 'success') => {
    return {
        label,
        labelParameters,
        type
    };
};

export const showMessage = (label, labelParameters = {}, type = 'success') => (dispatch) => {
    dispatch({
        type: 'ADD_MESSAGE',
        data: {
            label,
            labelParameters,
            type
        }
    });
};

export const showError = (label, error, labelParameters = {}) => (dispatch) => {
    if (error) {
        console.log(error);
    }
    dispatch(showMessage(label, labelParameters, 'error'));
};

export const clearMessages = () => (dispatch) => {
    dispatch({
        type: 'CLEAR_MESSAGES'
    });
};
